import React, {useState} from 'react';
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import {filter, sort} from "../../../service/ApiService";
import {useForm} from "react-hook-form";
import {stepCompletionResultType} from "../../../types/Api/StepResultType";
import {StepEdit} from "./StepEdit";

type FormDataType = {
  label?: string;
  distance?: number;
}

type StepListProps = {
  steps: stepCompletionResultType[],
  loading?: boolean,
  sort: sort,
  refresh: () => void,
  filter: (f: filter[]) => void,
  order: (s: string) => void,
}

export const StepList = ({steps, loading, sort, filter, order, refresh}: StepListProps) => {
  const [stepEdit, setStepEdit] = useState(undefined as undefined | stepCompletionResultType);

  const {
    register,
    handleSubmit,
  } = useForm<FormDataType>({
    defaultValues: {
      label: undefined,
    }
  });

  const onSubmit = async (data: FormDataType) => {
    const filters: filter[] = []

    if ((data.label || undefined) !== undefined) {
      filters.push({
        op: 'like',
        field: 'label',
        value: `*${data.label}*`
      })
    }

    filter(filters);
  }

  return (
    <>
      <form method="post" onSubmit={handleSubmit(onSubmit)}>
        <table className="table table-responsive table-hover border">
          <thead>
          <tr className="table-primary">
            <th onClick={() => order('label')} className="cursor-pointer">
              <span className={sort.by === 'label' ? 'd-flex justify-content-between' : ''}>
                Nom
                {sort.by === 'label' && (<>
                  <i className={`me-2 fa-solid ${sort.direction === 'DESC' ? 'fa-sort-up' : 'fa-sort-down'}`}/>
                </>)}
              </span>
            </th>
            <th onClick={() => order('count')} className="cursor-pointer">
              <span className={sort.by === 'count' ? 'd-flex justify-content-between' : ''}>
                Utilisation
                {sort.by === 'count' && (<>
                  <i className={`me-2 fa-solid ${sort.direction === 'DESC' ? 'fa-sort-up' : 'fa-sort-down'}`}/>
                </>)}
              </span>
            </th>
            <th className="w200px"></th>
          </tr>
          </thead>
          <tbody>
          {loading && (
            <tr>
              <td colSpan={3} className="pt-4 pb-4 ps-5 pe-5">
                <TableLineLoader/>
              </td>
            </tr>
          )}
          <tr>
            <td>
              <input id="form-label" type="text" className="form-control" placeholder="~" {...register('label')} />
            </td>
            <td colSpan={2} className="text-start align-middle">
              <button type="submit" className="btn btn-sm btn-success me-1">ok</button>
            </td>
          </tr>
          {!loading && steps.map((step: stepCompletionResultType, i: number) => (
            <tr key={i}>
              <td className="max-w400px">
                {step.label}
              </td>
              <td>
                {step.count}
              </td>
              <td className="text-end">
                <button className="btn btn-xs btn-primary me-1" onClick={() => setStepEdit(step)}>
                  <i className="fa-solid fa-pencil me-1"/> modifier
                </button>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </form>
      {stepEdit && (
        <StepEdit step={stepEdit} close={(r: boolean) => {
          if (r) {
            refresh();
          }
          setStepEdit(undefined);
        }}/>
      )}
    </>
  )
}
